const showMobileHeader = state => state.showMobileHeader;
const showDesktopHeader = state => state.showDesktopHeader;
const showGlobalModal = state => state.showGlobalModal;
const showCookiesModal = state => state.showCookiesModal;
const propositionViewModalId = state => state.propositionViewModalId;
const propositionViewModalId2 = state => state.propositionViewModalId2;
const propositionViewModalType = state => state.propositionType;
const pageModalActivePage = state => state.pageModalActivePage;
const pageModalZIndex = state => state.pageModalZIndex;
const tutorialActive = state => state.tutorialActive;
const disableScroll = state => state.disableScroll?.length > 0;
const activeModals = state => state.activeModals;
const usedModals = state => state.usedModals;
const currentModal = state => state.currentModal;
const tabAnsweredClicks = state => state.tabAnsweredClicks;
const endMatchConfirm = state => state.endMatchConfirm;
const completeListingModalData = state => state.completeListingModalData;

export default {
  showMobileHeader,
  showDesktopHeader,
  showGlobalModal,
  showCookiesModal,
  propositionViewModalId,
  propositionViewModalId2,
  propositionViewModalType,
  pageModalActivePage,
  pageModalZIndex,
  disableScroll,
  activeModals,
  usedModals,
  currentModal,
  tabAnsweredClicks,
  endMatchConfirm,
  completeListingModalData,
  tutorialActive
};
